import { useMutation } from '@apollo/client';
import { SYNC_OBJECT_RELATIONSHIPS } from '../../mutations';

export function useSyncObjectRelationshipsMutation() {
    return useMutation( SYNC_OBJECT_RELATIONSHIPS );
}
